import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.svg';
import GameCartoon1 from '../../assets/game-cartoon-image-1.png';
import GameCartoon2 from '../../assets/game-cartoon-image-2.png';

const HomePage = () => {
    return (
        <section className="pt-10 sm:pt-20 min-h-screen flex flex-col hero-bg">
            <img src={logo} alt="Game Gems Logo" className="mx-auto mb-6 sm:mb-10 w-40 sm:w-64" />
            <div className="container mx-auto px-4 sm:px-6 md:px-10 text-center flex-1">
                <div className="flex items-center justify-center flex-col md:flex-row">
                    <div>
                        <img src={GameCartoon1} alt="Game Cartoon" className="w-48 sm:w-80 md:w-100" />
                    </div>
                    <div className='px-2 sm:px-10 py-6 md:py-0'>
                        <h1 className="text-2xl sm:text-4xl md:text-5xl font-bold mb-4">Welcome to GameGems</h1>
                        <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-10">
                            Earn. Convert. Play. Discover your favorite games and trade gems like a pro.
                        </p>
                        <Link
                            to="#"
                            className="inline-block bg-gradient text-white hover:bg-gray-100 font-semibold py-3 px-6 rounded-lg transition text-base sm:text-lg"
                        >
                            Download App
                        </Link>
                    </div>
                    <div>
                        <img src={GameCartoon2} alt="Game Cartoon" className="w-40 sm:w-full sm:max-w-xs mx-auto" />
                    </div>
                </div>
            </div>
            <footer className="bg-gray-100 text-gray-600 py-6 px-4 sm:px-10 text-center text-sm flex flex-col md:flex-row items-center gap-3 md:justify-between">
                <span>&copy; {new Date().getFullYear()} GameGems. All rights reserved.</span>
                <ul className='flex flex-wrap justify-center gap-x-4 gap-y-1'>
                    <li><Link to="/privacy" className="text-gray-600 hover:underline">Privacy Policy</Link></li>
                    <li><Link to="/terms" className="text-gray-600 hover:underline">Terms of Service</Link></li>
                    <li><Link to="/need-help" className="text-gray-600 hover:underline">Need Help?</Link></li>
                </ul>
            </footer>
        </section>
    );
};

export default HomePage;
